import React, { useEffect } from 'react';
import { useLocation } from "react-router-dom";

import { trackView } from "../../helpers/analytics";
import Register from './Register';
import Signin from './Signin';
import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword';
import TextBlock from './TextBlock';
import ArticleBanner from './ArticleBanner';
import ArticleCarousel from './ArticleCarousel';
import SeriesCarousel from './SeriesCarousel';
import LeftRightImageText from './LeftRightImageText';
import ArticleTextContent from './ArticleTextContent';
import AdditionalResources from './AdditionalResources';
import RelatedContent from './RelatedContent';
import RelatedPodcasts from './RelatedPodcasts';
import Spotify from './Spotify';
import Speaker from './Speaker';
import Image from './Image';
import Subscribe from './Subscribe';
import ProductGrid from './ProductGrid';
import BookGrid from './BookGrid';
import BookDetail from './BookDetail';
import Player from './Player';
import SiteMap from './SiteMap';
import TextCard from './TextCard';
import PageBanner from "./PageBanner";
import AdditionalBook from './AdditionalBooks';
import DocumentViewer from './DocumentViewer';
import PhotoGallery from './PhotoGallery';
import Faqs from './Faqs';
import Sponsor from './Sponsor';
import CardCarosel from './CardCarousel';
import BookCard from './BookCard';
import BookBanner from './BookBanner';
import Banner from './Banner';
import ContactDetails from './ContactDetails';
import ContactUs from './ContactUs';
import MySavedList from './MySavedList';
import MyProfile from './MyProfile';
import CategoryBasedList from './CategoryBasedList';
import LoginRequired from './LoginRequired';
import EmbeddedPlayer from './EmbeddedPlayer';
import CallToAction from './CallToAction';
import LandingBanner from './LandingBanner';
import PlanList from './PlanList';
import ChangePaymentMethod from './ChangePaymentMethod';
import GiftRegister from './GiftRegister';
import RadeemGiftRegister from './RadeemGiftRegister';
import Newsletter from './Newsletter';
import MembershipBenefits from './MembershipBenefits';
import Reactivation from './Reactivation';
import ManualLinkSetup from './ManualLinkSetup';
import TermlyPolicy from './TermlyPolicy';

const Widget = ({ data, pageData}) => {
    const { pathname } = useLocation();
    useEffect(() => {
        trackView(pathname);
    }, [pathname]);
    if (data.type === "register") {
        return (
            <Register {...data} />
        )
    }

    if (data.type === "signin") {
        return (
            <Signin {...data} />
        )
    }

    if (data.type === "forgot_password") {
        return (
            <ForgotPassword {...data} />
        )
    }

    if (data.type === "reset_password") {
        return (
            <ResetPassword {...data} />
        )
    }

    if (data.type === "text_block") {
        return (
            <TextBlock {...data} />
        )
    }

    if (data.type === "article_banner") {
        return (
            <ArticleBanner {...data} />
        )
    }

    if (data.type === "article_carousel") {
        return (
            <ArticleCarousel {...data} />
        )
    }

    if (data.type === "series_carousel") {
        return (
            <SeriesCarousel {...data} />
        )
    }

    if (data.type === "left_right_image_text") {
        return (
            <LeftRightImageText {...data} />
        )
    }

    if (data.type === "article_text_content") {
        return (
            <ArticleTextContent {...pageData} />
        )
    }

    if (data.type === "additional_resources") {
        return (
            <AdditionalResources {...pageData} />
        )
    }

    if (data.type === "related_content") {
        return (
            <RelatedContent {...pageData} />
        )
    }

    if (data.type === "related_podcast_article") {
        return (
            <RelatedPodcasts {...pageData} />
        )
    }

    if (data.type === "spotify") {
        return (
            <Spotify {...pageData} />
        )
    }

    if (data.type === "speaker") {
        return (
            <Speaker {...data} {...pageData} />
        )
    }

    if (data.type === "image") {
        return (
            <Image {...data} />
        )
    }

    if (data.type === "subscribe") {
        return (
            <Subscribe {...data} {...pageData} />
        )
    }

    if (data.type === "product_grid") {
        return (
            <ProductGrid {...data} />
        )
    }

    if (data.type === "book_grid") {
        return (
            <BookGrid {...data}/>
        )
    }

    if (data.type === "book_text_content") {
        return (
            <BookDetail {...pageData} />
        )
    }

    if (data.type === "player") {
        return (
            <Player {...pageData} />
        )
    }

    if (data.type === "site_map") {
        return (
            <SiteMap {...data} />
        )
    }

    if (data.type === "text_card") {
        return (
            <TextCard {...data} />
        )
    }

    if (data.type === "page_banner") {
        return (
            <PageBanner {...pageData}/>
        )
    }

    if (data.type === "additional_resource_book") {
        return (
            <AdditionalBook {...pageData}/>
        )
    }

    if (data.type === "document_viewer") {
        return (
            <DocumentViewer {...pageData}/>
        )
    }

    if (data.type === "photo_gallery") {
        return (
            <PhotoGallery {...pageData}/>
        )
    }

    if (data.type === "faq") {
        return (
            <Faqs {...data}/>
        )
    }

    if (data.type === "sponsor") {
        return (
            <Sponsor {...data}/>
        )
    }

    if (data.type === "card_carousel") {
        return (
            <CardCarosel {...data}/>
        )
    }

    if (data.type === "book_card") {
        return (
            <BookCard {...data}/>
        )
    }

    if (data.type === "book_banner") {
        return (
            <BookBanner {...data}/>
        )
    }

    if (data.type === "banner") {
        return (
            <Banner {...data}/>
        )
    }

    if (data.type === "contact_details") {
        return (
            <ContactDetails {...data}/>
        )
    }

    if (data.type === "contact_us") {
        return (
            <ContactUs {...data}/>
        )
    }

    if (data.type === "my_saved_list") {
        return (
            <MySavedList {...data}/>
        )
    }

    if (data.type === "my_profile") {
        return (
            <MyProfile {...data}/>
        )
    }

    if (data.type === "category_based_list") {
        return (
            <CategoryBasedList {...pageData}/>
        )
    }

    if (data.type === "login_required") {
        return (
            <LoginRequired {...data}/>
        )
    }

    if (data.type === "embedded_player") {
        return (
            <EmbeddedPlayer {...data}/>
        )
    }

    if (data.type === "call_to_action") {
        return (
            <CallToAction {...data}/>
        )
    }

    if (data.type === "landing_banner") {
        return (
            <LandingBanner {...data}/>
        )
    }

    if (data.type === "plan_list") {
        return (
            <PlanList {...data}/>
        )
    }

    if (data.type === "change_payment_method") {
        return (
            <ChangePaymentMethod {...data}/>
        )
    }

    if (data.type === "gift_register") {
        return (
            <GiftRegister {...data}/>
        )
    }

    if(data.type === "radeem_gift_register") {
        return (
            <RadeemGiftRegister {...data}/>
        )
    }

    if(data.type === "newsletter") {
        return (
            <Newsletter {...data}/>
        )
    }

    if(data.type === "membership_benefits") {
        return (
            <MembershipBenefits {...data}/>
        )
    }
    
    if(data.type === "reactivation") {
        return (
            <Reactivation {...data}/>
        )
    }

    if(data.type === "manual_link_setup") {
        return (
            <ManualLinkSetup {...data}/>
        )
    }
    
    if(data.type === "termly_policy") {
        return (
            <TermlyPolicy {...data}/>
        )
    }

    return null;
}

export default Widget;